import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import * as layouts from "../../Layouts/index";

import homedata from "../../data/GramSchemes";
import NavAndFooter from "../Common/NavAndFooterContainer";
import LoadingComponet from "../../components/Loading/LoadingComponet";
import GetPageData from "../../hooks/GetPageData";
import LayoutContainer from "../../components/LayoutsContainer";
import { useParams } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      // backgroundColor: "white",
    },
  },
}));

const GramSchemes = () => {
  const classes = useStyles();
  const { schemeCategory } = useParams();

  const { ready, data, error } = GetPageData(
    schemeCategory ? `schemeByCategory/${schemeCategory}` : "scheme"
  );
  return ready && data ? (
    <div className={classes.root}>
      <LayoutContainer>
        {data?.data?.map((data, index) => {
          const Layout = layouts[data?.layout];

          return (
            <Layout key={index} data={data} schemeCategory={schemeCategory} />
          );
        })}
      </LayoutContainer>
    </div>
  ) : (
    <div>
      <LoadingComponet />
    </div>
  );
};
export default GramSchemes;
